const { upgradeArray } = require('../utils')

const SENDERNAME_SMS_OPERATOR_MODERATION_VALUES = upgradeArray([
  'disabled',
  'requested',
  'moderation',
  'approved',
  'rejected'
])

const PUBLIC_FIELDS_SENDERNAME = [ 'id', 'name', 'type', 'moderation', 'isActive' ]

const FULL_FIELDS_SENDERNAME = [ 'id', 'name', 'meta', 'type', 'moderation', 'isActive', 'updatedAt', 'createdAt' ]

module.exports = {
  PUBLIC_FIELDS_SENDERNAME,
  FULL_FIELDS_SENDERNAME,
  SENDERNAME_SMS_OPERATOR_MODERATION_VALUES
}
